<template>
  <div v-if="listStore.length == 0">
    <img v-bind:src="require('../../../assets/loading/loading.gif')" />
  </div>
  <div v-else>
    <!-- <v-col>
        <v-btn color="info" @click="check">Check</v-btn>
      </v-col> -->

    <v-col cols="12" class="pa-0 ma-0">
      <v-row>
        <v-col cols="3">
          <v-select
            :items="listStore"
            v-model="platformSelected"
            @change="filterStore(platformSelected)"
            outlined
            label="Store"
            dense
          ></v-select>
        </v-col>

        <v-col cols="3">
          <v-select
            :items="filterData"
            v-model="selectedFilter"
            @change="filterDataTable(selectedFilter)"
            outlined
            multiple
            label="Idea"
            dense
          >
            <template v-slot:prepend-item>
              <v-list-item ripple @click="toggle">
                <v-list-item-action>
                  <v-icon
                    :color="selectedFilter.length > 0 ? 'indigo darken-4' : ''"
                  >
                    {{ icon }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title> Select All </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2"></v-divider>
            </template>
          </v-select>
        </v-col>
        <v-col cols="3">
          <v-btn
            color="info"
            @click="exportToExcel"
            v-if="checkRoles('General Manager') || checkRoles('Administrator')"
            >Export To Excel</v-btn
          >
        </v-col>
      </v-row>
    </v-col>

    <v-row>
      <v-col cols="4"></v-col>
      <v-col cols="4">
        <b>Idea Profit {{ report_month }}</b>
      </v-col>
      <v-col cols="4"></v-col>
    </v-row>

    <div v-if="selectedFilter.length > 0">
      <b>{{ selectedFilter.join(" - ") }}</b>
    </div>

    <template v-if="selectedFilter.length == 0"> No Data Available </template>
    <table class="table table-striped" v-else>
      <thead class="thead-light">
        <tr>
          <th>Day Of Month</th>
          <!-- <th>Seller</th> -->
          <th>Total Order In Day</th>
          <th>Total Sales In Day</th>
          <th
            title="item revenue = (item price x item quantity) - item discount
                    + item shipping + item tip"
          >
            Revenue
          </th>
          <th
            title="item temp profit = item revenue - 0.1 x item revenue
                    - item temp base cost"
          >
            Temp Profit
          </th>
          <th
            title="item gross profit = item revenue - 0.1 x item revenue
                     - item real base cost"
          >
            Gross Profit
          </th>
          <th
            title="Facebook Ad Spent = Product Ad Spent + Seller Ad Spent + Store Ad Spent"
          >
            Facebook Ad Spent
          </th>
          <th
            title="Google Ad Spent = Product Ad Spent + Seller Ad Spent + Store Ad Spent"
          >
            Google Ad Spent
          </th>
          <th
            title="Tiktok Ad Spent = Product Ad Spent + Seller Ad Spent + Store Ad Spent"
          >
            Tiktok Ad Spent
          </th>
          <th title="item net profit = item gross profit - item total ad spent">
            Net Profit
          </th>
          <th title="ROI = item net profit x 100 / item total ad spent">ROI</th>
        </tr>
      </thead>
      <tbody>
        <template>
          <tr v-for="(i, index) of selectedData" :key="index">
            <td>
              {{ i["Day Of Month"] }}
            </td>
            <td>{{ i["Total Order In Day"] }}</td>
            <td>{{ i["Total Sales In Day"] }}</td>
            <td>{{ parseFloat(i.Revenue).toFixed(2) }}</td>
            <td>{{ parseFloat(i["Temp Profit"]).toFixed(2) }}</td>
            <td>{{ parseFloat(i["Gross Profit"]).toFixed(2) }}</td>
            <td>{{ parseFloat(i["Facebook Ad Spent"]).toFixed(2) }}</td>
            <td>{{ parseFloat(i["Google Ad Spent"]).toFixed(2) }}</td>
            <td>{{ parseFloat(i["Tiktok Ad Spent"]).toFixed(2) }}</td>
            <td>{{ parseFloat(i["Net Profit"]).toFixed(2) }}</td>
            <td>{{ i.ROI ? parseFloat(i.ROI).toFixed(2) + '%' : 'NaN' }}</td>
          </tr>
        </template>

        <!-- Total -->

        <tr>
          <td><b>Total</b></td>
          <!-- <td>
              <b>{{ item }}</b>
            </td> -->
          <td>
            <b>{{ this.totalData["Total Order"] }}</b>
          </td>
          <td>
            <b>{{ this.totalData["Total Sales"] }}</b>
          </td>
          <td>
            <b>{{ parseFloat(this.totalData["Revenue"]).toFixed(2) }}</b>
          </td>
          <td>
            <b>{{ parseFloat(this.totalData["Temp Profit"]).toFixed(2) }}</b>
          </td>
          <td>
            <b>{{ parseFloat(this.totalData["Gross Profit"]).toFixed(2) }}</b>
          </td>
          <td>
            <b>{{
              parseFloat(this.totalData["Facebook Ad Spent"]).toFixed(2)
            }}</b>
          </td>
          <td>
            <b>{{
              parseFloat(this.totalData["Google Ad Spent"]).toFixed(2)
            }}</b>
          </td>
          <td>
            <b>{{
              parseFloat(this.totalData["Tiktok Ad Spent"]).toFixed(2)
            }}</b>
          </td>
          <td>
            <b>{{ parseFloat(this.totalData["Net Profit"]).toFixed(2) }}</b>
          </td>
          <td>
            <b>{{ this.totalData["ROI"] ? parseFloat(this.totalData["ROI"]).toFixed(2) + '%' : 'NaN' }}</b>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import axios from "axios";
//import Vue from "vue";
//import HTTP from "../http-common"
import Amplify, { Auth } from "aws-amplify";
import XLSX from "xlsx";
import moment from "moment";

Amplify.configure({
  Auth: {
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_8vBdk5PAd",
    userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
    mandatorySignIn: true,
  },
});

export default {
  name: "StoreSellerProfit",

  props: {
    report_type: String,
    report_month: String,
    marketing: Boolean,
  },

  data: () => ({
    reportData: [],
    filterData: [],
    selectedFilter: [],
    selectedData: [],
    totalData: {},
    username: "",
    userSelected: [],
    listUserStores: null,
    listMarketingUser: [],
    listMarketingUserTotal: {},
    convertData: {},
    listStore: [],
    searchInput: null,
    platformSelected: "",
    checkbox1: false,
  }),

  computed: {
    likesAllStore() {
      return this.selectedFilter.length === this.filterData.length;
    },
    likesSomeStore() {
      return this.selectedFilter.length > 0 && !this.likesAllStore;
    },
    icon() {
      if (this.likesAllStore) return "mdi-close-box";
      if (this.likesSomeStore) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },

  created() {
    this.$root.$refs.storeSellerReport = this;
  },

  watch: {
    selectedFilter() {
      for (const i of this.selectedFilter) {
        if (i == "All") {
          console.log(i);
          this.checkbox1 = true;
          this.selectedFilter = this.filterData;
        }
      }
    },
  },

  methods: {
    async loadData() {
      this.reportData = [];
      this.filterData = [];
      this.selectedFilter = "";
      this.selectedData = [];

      var queryParams = {
        report_month: this.report_month,
        report_type: this.report_type,
      };

      var currentSession = await this.$root.$refs.App.currentSession(
        "profit-store-seller-loadData"
      );

      if (currentSession.accessToken) {
        await axios
          .get(window.domain + "reports/profit?", {
            headers: { Authorization: currentSession.accessToken },
            params: queryParams,
          })
          .then((response) => {
            // console.log(this.AuthStr)
            console.log("response: ", response);
            this.reportData = response.data.data;

            if (this.$cookies.get("stores") != null) {
              this.listUserStores = this.$cookies.get("stores").split(",");
            }
            this.getStore();
          })
          .catch((error) => {
            console.log("Error:", error);
            this.loading = false;
          });
      } else {
        console.log("profit-store-seller-loadData-undefined: ", currentSession);
      }
    },

    getStore() {
      //lay platform
      var tempStore = new Set();
      for (const j in this.reportData) {
        tempStore.add(this.reportData[j]["store_code"]);
        //this.convertData[j] = [];
      }

      this.listStore = Array.from(tempStore);
    },

    filterStore(store) {
      //lay ra list cac store
      this.filterData = [];
      this.selectedFilter = [];
      this.checkbox1 = false;
      this.selectedData = [];
      //this.filterData.push("All")
      for (const i in this.reportData) {
        if (this.reportData[i]["store_code"] == store) {
          this.filterData.push(i);
        }
      }
    },

    async filterDataTable(value) {
      console.log("filterDataTable value: ",value)
      //filter du lieu theo cac store duoc chon
      this.userSelected = [];
      this.listMarketingUser = [];
      this.listMarketingUserTotal = [];
      this.selectedData = [];

      this.totalData = {
        "Total Order": 0,
        "Total Sales": 0,
        Revenue: 0,
        "Temp Profit": 0,
        "Gross Profit": 0,
        "Facebook Ad Spent": 0,
        "Google Ad Spent": 0,
        "Tiktok Ad Spent": 0,
        "Net Profit": 0,
        ROI: 0,
      };

      var dayOfMonthTemp = [];
      for (var daytemp in this.reportData) {
        //lay ra cac ngay trong thang
        for (var day in this.reportData[daytemp]) {
          if (parseInt(day) >= 0) {
            dayOfMonthTemp.push(day);
          }
        }
        break;
      }

      for (var date of dayOfMonthTemp) {
        //lay du lieu tong theo cac ngay + theo store duoc chon
        var data = {
          "Day Of Month": "",
          "Total Order In Day": 0,
          "Total Sales In Day": 0,
          Revenue: 0,
          "Temp Profit": 0,
          "Gross Profit": 0,
          "Facebook Ad Spent": 0,
          "Google Ad Spent": 0,
          "Tiktok Ad Spent": 0,
          "Net Profit": 0,
          ROI: 0,
        };

        for (var store of value) {
          for (var dayStore in this.reportData[store]) {
            if (dayStore == date) {
              data["Day Of Month"] = date;
              data["Total Order In Day"] +=
                this.reportData[store][dayStore].total_orders_in_day;
              data["Total Sales In Day"] +=
                this.reportData[store][dayStore].total_sales_in_day;
              data["Revenue"] += this.reportData[store][dayStore].revenue;
              data["Temp Profit"] +=
                this.reportData[store][dayStore].temp_profit;
              data["Gross Profit"] +=
                this.reportData[store][dayStore].gross_profit;
              data["Facebook Ad Spent"] +=
                this.reportData[store][dayStore].facebook_ad_spent;
              data["Google Ad Spent"] +=
                this.reportData[store][dayStore].google_ad_spent;
              data["Tiktok Ad Spent"] +=
                this.reportData[store][dayStore].tiktok_ad_spent;
              data["Net Profit"] += this.reportData[store][dayStore].net_profit;
              data["ROI"] += this.reportData[store][dayStore].roi;
            }
          }
          //data["ROI"] = (data["Net Profit"] * 100) / data["Total Ad Spent"];
        }        
        this.selectedData.push(data);
      }

      for (var s of value) {
        console.log("s: ",s," - this.reportData[s]: ",this.reportData[s])
        //du lieu tong theo thang
        if (this.reportData[s]) {
          this.totalData["Total Order"] +=
            this.reportData[s].total_orders_in_month;
          this.totalData["Total Sales"] +=
            this.reportData[s].total_sales_in_month;
          this.totalData["Revenue"] += this.reportData[s].total_revenue;
          this.totalData["Temp Profit"] += this.reportData[s].total_temp_profit;
          this.totalData["Gross Profit"] +=
            this.reportData[s].total_gross_profit;
          this.totalData["Facebook Ad Spent"] +=
            this.reportData[s].total_facebook_ad_spent;
          this.totalData["Google Ad Spent"] +=
            this.reportData[s].total_google_ad_spent;
          this.totalData["Tiktok Ad Spent"] +=
            this.reportData[s].total_tiktok_ad_spent;
          this.totalData["Net Profit"] += this.reportData[s].total_net_profit;
          this.totalData["ROI"] += this.reportData[s].overall_roi;
        }
      }

      // this.totalData["ROI"] =
      //   (this.totalData["Net Profit"] * 100) / this.totalData["Total Ad Spent"];
    },

    toggle() {
      //action khi bam vao nut select all
      this.$nextTick(() => {
        if (this.likesAllStore) {
          this.selectedFilter = [];
        } else {
          this.selectedFilter = this.filterData.slice();
          this.filterDataTable(this.selectedFilter);
        }
      });
    },

    exportToExcel() {
      //export ra file excel
      var wb = XLSX.utils.book_new(); // make Workbook of Excel
      console.log(this.convertData);
      this.convertData = {
        "Export Data": [],
      };
      this.convertData["Export Data"] = JSON.parse(
        JSON.stringify(this.selectedData)
      );
      var total = {
        "Day Of Month": "Total",
        "Total Order In Day": this.totalData["Total Order"],
        "Total Sales In Day": this.totalData["Total Sales"],
        Revenue: this.totalData["Revenue"],
        "Temp Profit": this.totalData["Temp Profit"],
        "Gross Profit": this.totalData["Gross Profit"],
        "Facebook Ad Spent": this.totalData["Facebook Ad Spent"],        
        "Google Ad Spent": this.totalData["Google Ad Spent"],
        "Tiktok Ad Spent": this.totalData["Tiktok Ad Spent"],
        "Net Profit": this.totalData["Net Profit"],
        ROI: this.totalData["ROI"],
      };
      this.convertData["Export Data"].push(total);
      for (const a in this.convertData) {
        var b = XLSX.utils.json_to_sheet(this.convertData[a]);
        XLSX.utils.book_append_sheet(wb, b, a);
      }

      var current = moment().format("YYYY-MM-DD-h-mm-ss");

      var tempData = null;

      if (this.selectedFilter.length == this.filterData.length) {
        tempData = "ALL";
      } else {
        tempData = this.selectedFilter.join("-");
      }
      // export Excel file
      XLSX.writeFile(
        wb,
        this.report_type +
          "_" +
          this.report_month +
          "_" +
          tempData +
          "_" +
          current +
          ".xlsx"
      ); // name of the file is 'book.xlsx'
    },

    checkRoles(str) {
      var a = this.$root.$refs.App.hashCode(str);

      if (this.$cookies.get("roles") != null) {
        var role = this.$cookies.get("roles").split(",");
        var index = role.indexOf(a.toString());
        if (index != -1) return true;
        else return false;
      } else return false;
    },

    check() {
      console.log("reportData: ", this.reportData);
      console.log("convertData: ", this.convertData);
      console.log("selectedData: ", this.selectedData);
    },
  },

  async mounted() {
    console.log("marketing: ", this.marketing);
    console.log("Show Report");
    console.log(this.report_type);
    console.log(this.report_month);
    try {
      await Auth.currentAuthenticatedUser({ bypassCache: false });
      await this.loadData();
    } catch (error) {
      console.log("User logged out!");
      this.$router.push("/login");
    }
  },
};
</script>

<style scoped>
th {
  position: sticky;
  top: 0; /* Don't forget this, required for the stickiness */
}
* {
  text-transform: none !important;
}
</style>